import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auser',
  templateUrl: './auser.component.html',
  styleUrls: ['./auser.component.scss']
})
export class AUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
